module.exports = [() => (patient) => {
  if (patient) {
    return `${patient.firstName} ${patient.lastName}`;
  }
  return '';
}];



// WEBPACK FOOTER //
// ./main/filters/patient-name-filter.js